export const BREAKPOINT = {
  MOBILE: 768,
  TABLET: 1280,
} as const;
